import { useEffect } from 'react'

import { sortArrayBy } from '@domain-group/javascript-utils'
import { useSetState } from '@domain-group/react-hooks'

import useLayoutTemplates from '@hooks/useLayoutTemplates'
import usePublicationProducts from '@hooks/usePublicationProducts'

type DefaultState = {
  selectedLayoutTemplateId?: number,
  selectedPublicationProductId?: number,
}

const defaultState: DefaultState = {
  selectedLayoutTemplateId: undefined,
  selectedPublicationProductId: undefined,
}

type UseSelectLayoutTemplateModalOptions = {
  layoutTemplateId: number,
  publicationId: number,
  publicationProductId: number,
}

function useSelectLayoutTemplateModal(options: UseSelectLayoutTemplateModalOptions) {
  const {
    layoutTemplateId,
    publicationId,
    publicationProductId,
  } = options

  const [state, setState] = useSetState(defaultState)
  const {
    selectedLayoutTemplateId,
    selectedPublicationProductId,
  } = state

  // Autoselect
  useEffect(() => {
    if (layoutTemplateId && !selectedLayoutTemplateId){
      setState({
        selectedLayoutTemplateId: layoutTemplateId,
      })
    }
  }, [layoutTemplateId])

  useEffect(() => {
    if (publicationProductId && !selectedPublicationProductId){
      setState({
        selectedPublicationProductId: publicationProductId,
      })
    }
  }, [publicationProductId])

  // Layout Templates
  const layoutTemplatesPayload = useLayoutTemplates({
    filters: {
      compatible_product_id: selectedPublicationProductId,
      publication_id: publicationId,
    },
    performHttpRequests: false,
  })

  // Publication Products
  const publicationProductsPayload = usePublicationProducts({
    filters: {
      publication_id: publicationId,
    },
    performHttpRequests: false,
  })

  const {
    filteredPublicationProducts,
  } = publicationProductsPayload

  const saveEnabled = !!selectedLayoutTemplateId

  return {
    callbacks: {
      setState,
    },
    layoutTemplatesPayload,
    publicationProductsPayload,
    saveEnabled,
    sortedPublicationProducts: sortArrayBy(
      filteredPublicationProducts,
      'desc',
      ({ columns, rows }) => columns * rows,
    ),
    state,
  }
}

export default useSelectLayoutTemplateModal
